import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { getMoment } from '../services/datetime.service';

@Pipe({
  name: 'fullTimePresentation',
})
export class FullTimePresentationPipe implements PipeTransform {
  public transform(value: string, args?: any): string {
    if (value === '0001-01-01T00:00:00+00:00' || value === '1900-01-01T00:00:00+00:00' || value === '-') {
      return '-';
    }
    const format = `${environment.dateFormatSystem} ${environment.timeFormat}`;
    const message = getMoment(value, format).format('HH:mm:ss');
    return message;
  }
}
